import { Flex, type FlexProps } from '@commons/containers/Flex';

/**
 * BasicSectionRegion component.
 */

const BasicSectionRegion = (props: FlexProps) => {
  const { children, ref, ...rest } = props;

  return (
    <Flex ref={ref} direction="column" {...rest}>
      {children}
    </Flex>
  );
};

export default BasicSectionRegion;
